import React, { ReactNode } from 'react';
import { classNames } from '../common/helpers';

const cardShadowStyle = {
  large: 'shadow-lg',
  none: 'border-solid border-2'
}
interface CardProps {
  children: ReactNode,
  cardShadow?: 'large' | 'none',
  style?: string,
  title?: string,
  titlePosition?: 'topLeft' | 'borderTopLeft';
  overflowAuto?: boolean;
}

export const Card: React.FC<CardProps> = ({ children, style, title, titlePosition = 'topLeft', cardShadow = 'large', overflowAuto = false }) => {
  return (
    <div className={classNames(
      'relative width-100 bg-white p-[24px] rounded-lg md:mb-[40px]',
      overflowAuto ? 'overflow-auto' : 'overflow-hidden',
      cardShadow === 'large' ? cardShadowStyle.large : cardShadowStyle.none,
      style
    )}>
      {title && titlePosition === 'borderTopLeft' ?
        <div className='text-md text-gray-900 font-bold' >{title}</div> :
        <div className='text-md text-gray-900 font-bold'>{title}</div>
      }
      {children}
    </div>
  );
};

export { default as DashboardStatCard } from './DashboardStatCard';
